import Link from 'next/link';
import { FC } from 'react';
//styles
import styles from './condensed-footer-content.module.scss';

//assets
import { type CustomTextLink, condensedFooterLinks } from 'Data/footer-assets';
import { useIntl } from 'react-intl';

const CondensedFooterContent: FC = () => {
  const { formatMessage } = useIntl();

  const renderCondensedFooterLink = (link: CustomTextLink, index: any) => (
    <div className={styles.customLinkContainer} key={link.id} data-testid="link-container">
      <Link
        data-testid={`link-${index}`}
        className={styles.customLinkAnchor}
        {...link.anchorProps['en']}
        ref={undefined} // Temporary fix; the problem is the link data was made for vanilla anchor elements, not NextJS Links
      >
        {formatMessage({ id: link.textId })}
      </Link>
    </div>
  );

  return (
    <div className={styles.condensedFooterContainer} data-testid="condensed-footer-container">
      {condensedFooterLinks.map((link, index) => renderCondensedFooterLink(link, index))}
    </div>
  );
};

export default CondensedFooterContent;
